export const ContractStates = [
  { id: "OnSubjects", label: "On Subjects" },
  { id: "AllSubjectsLifted", label: "All Subjects Lifted" },
  { id: "PendingSellerConfirmation", label: "Pending Seller Confirmation" },
  { id: "PendingBuyerConfirmation", label: "Pending Buyer Confirmation" },
  { id: "Completed", label: "Completed" },
]